import styled from 'styled-components';

import { Styling, Colors, Animations } from '../../../../constants';
import { IActiveNavOptionProps } from './interfaces';

export const NavOptionContainer = styled.div<IActiveNavOptionProps>`
  display: flex;
`;

export const Container = styled.div`
  margin-left: ${Styling.DEFAULT_SPACING}px;
  display: flex;
  flex-direction: row;
  flex-grow: 0;
  align-items: center;
`;
